import createIcon from '../../createIcon';

/**
 * @component @name DoorSliding
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWNUMyMCAzLjkgMTkuMSAzIDE4IDNIMTIuNzVWMTlIMTEuMjVWM0g2QzQuOSAzIDQgMy45IDQgNVYxOUgzVjIxSDIxVjE5SDIwWk0xMCAxM0g4VjExSDEwVjEzWk0xNiAxM0gxNFYxMUgxNlYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoorSliding = createIcon('DoorSliding', [
  [
    'path',
    {
      d: 'M20 19V5C20 3.9 19.1 3 18 3H12.75V19H11.25V3H6C4.9 3 4 3.9 4 5V19H3V21H21V19H20ZM10 13H8V11H10V13ZM16 13H14V11H16V13Z',
      key: 'mv7nf6',
    },
  ],
]);

export default DoorSliding;
